import './style.scss';

function initHomeHero(block) {
  if (block.dataset.homeHeroInitialized === 'true') {
    return;
  }

  const video = block.querySelector('[data-home-hero-video]');

  if (!video) {
    return;
  }

  block.dataset.homeHeroInitialized = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  let isVisible = true;
  // Was gated on window 'load', which is the LAST event on the page: the hero
  // - the first thing anyone sees - waited for every image and script below it
  // before it was even asked to play. The video is the hero's content, so it
  // starts as soon as the element is on screen. The poster covers the gap
  // until the first frame is ready, and preload=metadata means the browser has
  // already opened the file by then.
  let pageLoaded = true;

  const pauseVideo = () => {
    video.pause();
  };

  const playVideo = () => {
    if (
      document.hidden ||
      !isVisible ||
      !pageLoaded ||
      reducedMotion.matches ||
      saveData
    ) {
      return;
    }

    const playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  video.muted = true;
  video.defaultMuted = true;

  // Start the loop from a random point every load, snapped to the nearest 10%
  // of its duration, so repeat visits (and page reloads) don't always open on
  // the same frame.
  const setRandomStart = () => {
    const {duration} = video;

    if (!isFinite(duration) || duration <= 0) return;

    // The inline starter in render.php has already chosen a start position -
    // it runs on the markup, long before this bundle arrives. Re-rolling it
    // here would visibly jump the reel to a second random point.
    if (video.dataset.heroStart) return;

    video.dataset.heroStart = '1';

    const step = 10;
    const steps = Math.floor(100 / step);
    const percent = Math.floor(Math.random() * steps) * step;

    video.currentTime = (duration * percent) / 100;
  };

  video.addEventListener('loadedmetadata', setRandomStart, {once: true});

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        isVisible = entry.isIntersecting;

        if (isVisible) {
          playVideo();
        } else {
          pauseVideo();
        }
      });
    }, {threshold: 0.05});

    observer.observe(block);
  }

  // Still nudge it once everything else has settled, in case the element was
  // off screen or the first play() was rejected while the tab was busy.
  window.addEventListener('load', () => playVideo(), {once: true});

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      pauseVideo();
    } else {
      playVideo();
    }
  });

  reducedMotion.addEventListener('change', (event) => {
    if (event.matches) {
      pauseVideo();
    } else {
      playVideo();
    }
  });

  if (pageLoaded) {
    playVideo();
  }
}

export function home_hero(root = document) {
  const selector = '[data-component="home-hero"]';
  const context = root || document;
  const blocks = [];

  if (context.nodeType === 1 && context.matches(selector)) {
    blocks.push(context);
  }

  if (context.querySelectorAll) {
    blocks.push(...context.querySelectorAll(selector));
  }

  blocks.forEach(initHomeHero);
}
